import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Sidebar from "@/components/Sidebar";
import Dashboard from "@/pages/Dashboard";
import { WaBillingBanner } from "@/components/WaBillingBanner";
import Clients from "@/pages/Clients";
import Invoices from "@/pages/Invoices";
import Automations from "@/pages/Automations";
import Importer from "@/pages/Importer";
import Logs from "@/pages/Logs";
import Avisos from "@/pages/Avisos";
import Informacoes from "@/pages/Informacoes";
import Settings from "@/pages/Settings";
import Privacy from "@/pages/Privacy";
import RefChat from "@/pages/RefChat";
import Responses from "@/pages/Responses";
import Login from "@/pages/Login";
import Dados from "@/pages/Dados";
import Chat from "@/pages/Chat";
import { ChatProvider } from "@/components/chat/ChatProvider";
import { WaitAlarm } from "@/components/WaitAlarm";
import { ChatDock, DOCK_KEY } from "@/components/chat/ChatDock";
import { AuthProvider, RequireAuth, RequireAdmin } from "@/components/auth/AuthProvider";
import { InboxProvider } from "@/components/inbox/InboxProvider";

function Shell() {
  const [dock, setDockState] = useState(() => { const v = localStorage.getItem(DOCK_KEY); return window.innerWidth >= 1440 && (v ? v === "1" : true); });
  const setDock = (v) => { localStorage.setItem(DOCK_KEY, v ? "1" : "0"); setDockState(v); };
  const { pathname } = useLocation();
  const docked = dock && !pathname.startsWith("/chat");
  return (
    <>
      <main className={`lg:ml-64 min-h-screen ${docked ? "min-[1440px]:mr-[420px]" : ""}`}>
        <div className="max-w-7xl px-4 sm:px-6 lg:px-8 py-6 sm:py-8">
          <WaBillingBanner />
          <Outlet />
        </div>
      </main>
      <ChatDock open={dock} setOpen={setDock} />
    </>
  );
}

function Layout() {
  return (
    <RequireAuth>
    <InboxProvider>
    <ChatProvider>
    <div className="min-h-screen bg-[#0B0F17]">
      <Sidebar />
      <Shell />
      <Toaster theme="dark" position="bottom-center" richColors />
      <WaitAlarm />
    </div>
    </ChatProvider>
    </InboxProvider>
    </RequireAuth>
  );
}

function App() {
  useEffect(() => { document.documentElement.classList.add("dark"); }, []);
  return (
    <BrowserRouter>
      <AuthProvider>
      <Routes>
        <Route path="/privacidade" element={<Privacy />} />
        <Route path="/c/:code" element={<RefChat />} />
        <Route path="/login" element={<Login />} />
        <Route element={<Layout />}>
          <Route path="/" element={<Dashboard />} />
          <Route path="/clientes" element={<Clients />} />
          <Route path="/faturas" element={<Invoices />} />
          <Route path="/automacoes" element={<Automations />} />
          <Route path="/importador" element={<RequireAdmin><Importer /></RequireAdmin>} />
          <Route path="/historico" element={<Logs />} />
          <Route path="/avisos" element={<Avisos />} />
          <Route path="/avisos/informacoes" element={<Informacoes />} />
          <Route path="/respostas" element={<Responses />} />
          <Route path="/chat" element={<Chat />} />
          <Route path="*" element={<Navigate to="/" replace />} />
          <Route path="/dados" element={<RequireAdmin><Dados /></RequireAdmin>} />
          <Route path="/configuracoes" element={<RequireAdmin><Settings /></RequireAdmin>} />
        </Route>
      </Routes>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
